module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/core-js/modules/_html.js
// module id = 180
// module chunks = 2 3 4 5 6 7 8 9 10 11 12